import type { ChapterList } from '@jojotique/server'
import { generateCard } from '@comp/template/Card/generate.ts'
import { getImgUrl } from '@core/utils/url.ts'
import { b } from '@utils/build.ts'

interface DescriptionCard {
  abstract: string
  linkPath: string
  linkTitle: string
  path: string
  title: string
}

export const useHome = () => {
  const getButtonText = (i: number): string => {
    switch (i) {
      case 0:
        return 'Voir le cours'
      case 1:
        return 'Découvrir'
      case 2:
      default:
        return 'Apprendre'
    }
  }

  const initChapterNewsOnClient = (chaptersNewsContainer: HTMLUListElement, chapters: ChapterList[]) => {
    chaptersNewsContainer.innerHTML = ''
    chapters.forEach((chapter, i) => {
      const listItem = b('li', document, {
        children: [
          generateCard(
            document,
            {
              abstract: chapter.abstract ?? '',
              buttonText: getButtonText(i),
              id: chapter.id,
              src: getImgUrl(chapter.thumbnail?.name ?? ''),
              title: chapter.title,
              linkPath: `/chapter/${chapter.slug}`,
              linkText: `Naviguer vers le chapitre "${chapter.title}"`,
            },
            {
              type: i % 2 === 0 ? 'primary' : 'secondary',
              hover: true,
            },
          ),
        ],
      })
      chaptersNewsContainer?.appendChild(listItem)
    })
  }

  const descriptionCards: DescriptionCard[] = [
    {
      abstract: "Explorez notre galaxie de connaissances et choisissez votre prochaine mission d'apprentissage.",
      linkPath: '/courses',
      linkTitle: "Commencer l'aventure",
      path: 'M15 9L12 0L9 9L0 12L9 15L12 24L15 15L24 12L15 9M4 12L10 10L11 12H4M12 20L10 14L12 13V20M12 4L14 10L12 11V4M14 14L13 12H20L14 14M8.7 17.3L5 19L6.7 15.3L8.3 15.8L8.7 17.3M17.3 15.3L19 19L15.3 17.3L15.8 15.7L17.3 15.3M6.7 8.7L5 5L8.7 6.7L8.2 8.2L6.7 8.7M15.3 6.7L19 5L17.3 8.7L15.7 8.2L15.3 6.7Z',
      title: 'Registre des cours',
    },
    {
      abstract:
        "Des contrats courts et ciblés. Parfait pour une escarmouche tactique : on identifie la cible, on apprend, et on s'exfiltre.",
      linkPath: '/tutorials',
      linkTitle: 'Choisir sa mission',
      path: 'M11,2V4.07C7.38,4.53 4.53,7.38 4.07,11H2V13H4.07C4.53,16.62 7.38,19.47 11,19.93V22H13V19.93C16.62,19.47 19.47,16.62 19.93,13H22V11H19.93C19.47,7.38 16.62,4.53 13,4.07V2M11,6.08V8H13V6.09C15.5,6.5 17.5,8.5 17.92,11H16V13H17.91C17.5,15.5 15.5,17.5 13,17.92V16H11V17.91C8.5,17.5 6.5,15.5 6.08,13H8V11H6.09C6.5,8.5 8.5,6.5 11,6.08M12,11A1,1 0 0,0 11,12A1,1 0 0,0 12,13A1,1 0 0,0 13,12A1,1 0 0,0 12,11Z',
      title: 'Tableau des tutoriels',
    },
    {
      abstract:
        'Votre armurerie personnelle. Récupérez du stuff HTML/CSS brut et redoutable pour équiper vos prochaines runs.',
      linkPath: '/components',
      linkTitle: 'Trouver son équipement',
      path: 'M6.92,5H5L14,14L15,13.06M19.96,19.12L19.12,19.96C18.73,20.35 18.1,20.35 17.71,19.96L14.59,16.84L11.91,19.5L10.5,18.09L11.92,16.67L3,7.75V3H7.75L16.67,11.92L18.09,10.5L19.5,11.91L16.83,14.58L19.95,17.7C20.35,18.1 20.35,18.73 19.96,19.12Z',
      title: 'Arsenal de composants natif',
    },
  ]

  const initDescriptionCards = (document: Document, descriptionCardsContainer: HTMLUListElement) => {
    descriptionCards.forEach((card, i) => {
      const listItem = document.createElement('li')
      listItem.appendChild(
        generateCard(
          document,
          {
            title: card.title,
            abstract: card.abstract,
            path: card.path,
            src: card.linkPath,
            buttonText: card.linkTitle,
            linkPath: card.linkPath,
            linkText: card.linkTitle,
          },
          {
            hover: true,
          },
        ),
      )
      descriptionCardsContainer?.appendChild(listItem)
    })
  }

  return {
    initChapterNewsOnClient,
    initDescriptionCards,
  }
}
